(function () {
  "use strict";

  var drawerId = "ArproCartDrawer";
  var drawerSectionId = "arpro-cart-drawer";
  var pendingContextKey = "arpro_pending_price_context";
  var lastDrawerTrigger = null;
  var lastTariffTrigger = null;
  var lastTariffRoot = null;
  var cartMutation = null;
  var checkoutBlockReason = "";
  var uiSynchronizationLocked = false;

  function rootUrl() {
    var root = document.body && document.body.dataset.arproRootUrl;
    if (!root && window.Shopify && window.Shopify.routes) root = window.Shopify.routes.root;
    root = root || "/";
    return root.endsWith("/") ? root : root + "/";
  }

  function cartRoute(path) {
    return rootUrl() + path.replace(/^\//, "");
  }

  function normalizeMode(value) {
    var mode = String(value || "").trim().toUpperCase();
    return mode === "TRAD" || mode === "GROSSISTES" ? mode : "";
  }

  function liveRegion() {
    return document.querySelector("[data-arpro-cart-live]");
  }

  function announce(message, assertive) {
    var region = liveRegion();
    if (!region) return;
    region.setAttribute("aria-live", assertive ? "assertive" : "polite");
    region.textContent = "";
    window.setTimeout(function () {
      var currentRegion = liveRegion();
      if (currentRegion) currentRegion.textContent = message;
    }, 30);
  }

  function errorMessage(payload, fallback) {
    if (!payload) return fallback;
    if (typeof payload.description === "string") return payload.description;
    if (typeof payload.message === "string") return payload.message;
    if (typeof payload.errors === "string") return payload.errors;
    if (payload.errors && typeof payload.errors === "object") {
      return Object.keys(payload.errors).map(function (key) {
        var value = payload.errors[key];
        return Array.isArray(value) ? value.join(", ") : String(value);
      }).join(" · ");
    }
    return fallback;
  }

  function sectionIds() {
    var ids = [drawerSectionId];
    document.querySelectorAll("[data-arpro-header-section-id], [data-arpro-cart-page-section-id], [data-arpro-tariff-section-id]").forEach(function (element) {
      var id = element.dataset.arproHeaderSectionId
        || element.dataset.arproCartPageSectionId
        || element.dataset.arproTariffSectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function sectionRequestUrl() {
    return window.location.pathname + window.location.search;
  }

  function prepareSection(id, html) {
    if (typeof html !== "string") return false;
    var target = document.getElementById("shopify-section-" + id);
    if (!target) return false;

    var parsed = new DOMParser().parseFromString(html, "text/html");
    var source = parsed.getElementById("shopify-section-" + id);
    if (!source) return false;
    source.querySelectorAll("noscript").forEach(function (element) {
      element.remove();
    });
    return { id: id, target: target, source: source };
  }

  function syncTextAndHidden(target, source, selector) {
    var current = target.querySelector(selector);
    var next = source.querySelector(selector);
    if (!current || !next) return false;
    current.textContent = next.textContent;
    current.hidden = next.hidden;
    return true;
  }

  function replacePreparedSection(prepared) {
    var target = prepared.target;
    var source = prepared.source;
    if (source && target.querySelector("[data-arpro-header-section-id]")) {
      var currentHeaderRoot = target.querySelector("[data-arpro-header-section-id]");
      var nextHeaderRoot = source.querySelector("[data-arpro-header-section-id]");
      if (!currentHeaderRoot || !nextHeaderRoot) return false;
      currentHeaderRoot.dataset.arproContextAuthoritative =
        nextHeaderRoot.dataset.arproContextAuthoritative === "true" ? "true" : "false";
      currentHeaderRoot.dataset.arproAuthoritativeMode =
        normalizeMode(nextHeaderRoot.dataset.arproAuthoritativeMode);

      var currentCartLink = target.querySelector("[data-arpro-cart-open]");
      var nextCartLink = source.querySelector("[data-arpro-cart-open]");
      if (currentCartLink && nextCartLink) {
        currentCartLink.setAttribute("aria-label", nextCartLink.getAttribute("aria-label") || "Panier");
        var currentCount = currentCartLink.querySelector("[data-arpro-cart-count]");
        var nextCount = nextCartLink.querySelector("[data-arpro-cart-count]");
        if (currentCount && nextCount) {
          currentCount.textContent = nextCount.textContent;
          currentCount.hidden = nextCount.hidden;
        }
      }
      syncTextAndHidden(target, source, "[data-arpro-header-cart-total]");
      return true;
    }
    if (source && target.querySelector("[data-arpro-tariff-root]")) {
      var currentTariffRoot = target.querySelector("[data-arpro-tariff-root]");
      var nextTariffRoot = source.querySelector("[data-arpro-tariff-root]");
      if (currentTariffRoot && nextTariffRoot) {
        currentTariffRoot.dataset.arproCartItemCount = nextTariffRoot.dataset.arproCartItemCount || "0";
        currentTariffRoot.dataset.arproCurrentMode = nextTariffRoot.dataset.arproCurrentMode || "unassigned";
        currentTariffRoot.dataset.arproAccessStatus = nextTariffRoot.dataset.arproAccessStatus || "public";

        var currentChoices = currentTariffRoot.querySelector("[data-arpro-tariff-choices]");
        var nextChoices = nextTariffRoot.querySelector("[data-arpro-tariff-choices]");
        if (currentChoices && nextChoices) currentChoices.replaceChildren.apply(currentChoices, Array.from(nextChoices.children).map(function (child) {
          return child.cloneNode(true);
        }));

        var currentActive = currentTariffRoot.querySelector(".arpro-tariff__active");
        var nextActive = nextTariffRoot.querySelector(".arpro-tariff__active");
        if (currentActive && nextActive) currentActive.replaceWith(nextActive.cloneNode(true));
      }
      syncTextAndHidden(target, source, "[data-arpro-mobile-cart-count]");
      syncTextAndHidden(target, source, "[data-arpro-mobile-cart-total]");
      return true;
    }
    target.replaceWith(source);
    return true;
  }

  function captureRefreshFocus() {
    var active = document.activeElement;
    if (!active || active === document.body) return null;
    var line = active.closest && active.closest("[data-arpro-cart-line]");
    var descriptor = {
      scope: active.closest && active.closest("[data-arpro-cart-drawer]") ? "drawer" : "page",
      lineKey: line && line.dataset.lineKey,
      control: ""
    };
    if (active.matches("[data-arpro-cart-quantity]")) descriptor.control = "quantity";
    else if (active.matches("[data-arpro-cart-remove]")) descriptor.control = "remove";
    else if (active.matches("[data-arpro-quantity-step]")) descriptor.control = "step:" + active.dataset.arproQuantityStep;
    else if (active.matches("button[name='update']")) descriptor.control = "update";
    else if (active.matches("[data-arpro-checkout]")) descriptor.control = "checkout";
    return descriptor;
  }

  function restoreRefreshFocus(descriptor) {
    if (!descriptor) return false;
    var scope = descriptor.scope === "drawer"
      ? document.querySelector("[data-arpro-cart-drawer]")
      : document.querySelector("[data-arpro-cart-page-section-id]");
    if (!scope) return false;
    var target = null;
    if (descriptor.lineKey) {
      Array.from(scope.querySelectorAll("[data-arpro-cart-line]")).some(function (line) {
        if (line.dataset.lineKey !== descriptor.lineKey) return false;
        if (descriptor.control === "quantity") target = line.querySelector("[data-arpro-cart-quantity]");
        else if (descriptor.control === "remove") target = line.querySelector("[data-arpro-cart-remove]");
        else if (descriptor.control.indexOf("step:") === 0) {
          target = line.querySelector("[data-arpro-quantity-step='" + descriptor.control.slice(5) + "']");
        }
        return Boolean(target);
      });
    }
    if (!target && descriptor.control === "update") target = scope.querySelector("button[name='update']");
    if (!target && descriptor.control === "checkout") target = scope.querySelector("[data-arpro-checkout]:not([disabled])");
    if (!target && descriptor.scope === "drawer") target = scope.querySelector("[data-arpro-cart-close]");
    if (!target && descriptor.scope === "page") target = scope.querySelector("h1, h2, a, button");
    if (!target) return false;
    if (!target.matches("a, button, input, select, textarea, [tabindex]")) target.setAttribute("tabindex", "-1");
    target.focus({ preventScroll: true });
    return true;
  }

  function applySections(sections, reopenDrawer, requiredIds) {
    if (!sections || typeof sections !== "object") {
      uiSynchronizationLocked = true;
      return 0;
    }
    var ids = Array.isArray(requiredIds) && requiredIds.length > 0 ? requiredIds : Object.keys(sections);
    var prepared = ids.map(function (id) {
      if (!Object.prototype.hasOwnProperty.call(sections, id)) return false;
      return prepareSection(id, sections[id]);
    });
    if (prepared.some(function (section) { return !section; })) {
      uiSynchronizationLocked = true;
      return 0;
    }

    var currentDrawer = document.getElementById(drawerId);
    var shouldReopen = Boolean(reopenDrawer || (currentDrawer && currentDrawer.open));
    var focusDescriptor = captureRefreshFocus();
    var replaced = 0;

    prepared.forEach(function (section) {
      if (replacePreparedSection(section)) replaced += 1;
    });
    var synchronizedState = authoritativeState();
    uiSynchronizationLocked = replaced !== ids.length
      || !synchronizedState.authoritative
      || !synchronizedState.mode
      || synchronizedState.cartMode !== synchronizedState.mode;

    if (shouldReopen) openDrawer(lastDrawerTrigger, true);
    if (!restoreRefreshFocus(focusDescriptor) && shouldReopen) {
      var newDrawer = document.getElementById(drawerId);
      var close = newDrawer && newDrawer.querySelector("[data-arpro-cart-close]");
      if (close) close.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent("arpro:sections-updated", {
      detail: { ids: ids.slice(), root: document }
    }));
    if (cartMutation) setMutationControlsBusy(true);
    if (checkoutBlockReason) setCheckoutBlocked(checkoutBlockReason);
    return replaced;
  }

  async function parseResponse(response) {
    var payload;
    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }
    if (!response.ok) {
      throw new Error(errorMessage(payload, "Shopify n’a pas pu mettre le panier à jour."));
    }
    return payload || {};
  }

  async function refreshSections(reopenDrawer) {
    var url = new URL(window.location.href);
    var requestedIds = sectionIds();
    url.searchParams.set("sections", requestedIds.join(","));
    var response = await fetch(url.toString(), {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });
    var payload = await parseResponse(response);
    var replaced = applySections(payload, reopenDrawer, requestedIds);
    if (replaced !== requestedIds.length) {
      throw new Error("Shopify n’a pas rendu toutes les zones du panier demandées.");
    }
    return payload;
  }

  async function postJson(endpoint, body, options) {
    var settings = options || {};
    var payload = Object.assign({}, body);
    var requestedIds = [];
    if (settings.sections !== false) {
      requestedIds = sectionIds();
      payload.sections = requestedIds;
      payload.sections_url = sectionRequestUrl();
    }

    var response = await fetch(cartRoute(endpoint), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });
    var result = await parseResponse(response);
    if (result.sections && applySections(result.sections, settings.reopenDrawer, requestedIds) === requestedIds.length) {
      /* Every requested server-rendered surface was replaced. */
    } else if (settings.sections !== false) {
      await refreshSections(settings.reopenDrawer);
    }
    return result;
  }

  function setCheckoutBlocked(message) {
    checkoutBlockReason = message || "Validation du contexte Shopify requise avant checkout.";
    document.querySelectorAll("[data-arpro-checkout]").forEach(function (button) {
      if (!Object.prototype.hasOwnProperty.call(button.dataset, "arproWasCheckoutDisabled")) {
        button.dataset.arproWasCheckoutDisabled = button.disabled ? "true" : "false";
      }
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
    });
    document.querySelectorAll("[data-arpro-context-sync-message]").forEach(function (element) {
      element.textContent = checkoutBlockReason;
    });
  }

  function clearCheckoutBlocked() {
    var buttons = Array.from(document.querySelectorAll("[data-arpro-checkout]"));
    var serverReadinessAgrees = buttons.length === 0 || buttons.every(function (button) {
      return button.dataset.arproServerCheckoutAllowed === "true";
    });
    checkoutBlockReason = serverReadinessAgrees
      ? ""
      : "Les surfaces Shopify ne confirment pas toutes la disponibilité du checkout. Checkout bloqué.";
    buttons.forEach(function (button) {
      if (serverReadinessAgrees) {
        button.disabled = false;
        button.setAttribute("aria-disabled", "false");
      } else {
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
      }
      delete button.dataset.arproWasCheckoutDisabled;
    });
    document.querySelectorAll("[data-arpro-context-sync-message]").forEach(function (element) {
      element.textContent = checkoutBlockReason || "Contexte tarifaire Shopify confirmé.";
    });
    return serverReadinessAgrees;
  }

  function setMutationControlsBusy(busy) {
    document.querySelectorAll(
      "[data-arpro-add-button], [data-arpro-cart-quantity], [data-arpro-cart-remove], " +
      "[data-arpro-quantity-step], [data-arpro-cart-form] button"
    ).forEach(function (control) {
      if (!("disabled" in control)) return;
      if (busy) {
        if (!Object.prototype.hasOwnProperty.call(control.dataset, "arproMutationWasDisabled")) {
          control.dataset.arproMutationWasDisabled = control.disabled ? "true" : "false";
        }
        control.disabled = true;
      } else if (Object.prototype.hasOwnProperty.call(control.dataset, "arproMutationWasDisabled")) {
        control.disabled = control.dataset.arproMutationWasDisabled === "true";
        delete control.dataset.arproMutationWasDisabled;
      }
    });
  }

  function setControlBusy(control, busy) {
    if (!control) return;
    var form = control.closest && control.closest("form");
    if (form) form.setAttribute("aria-busy", busy ? "true" : "false");
    control.setAttribute("aria-busy", busy ? "true" : "false");
    if ("disabled" in control) {
      if (busy) {
        control.dataset.arproWasDisabled = control.disabled ? "true" : "false";
        control.disabled = true;
      } else {
        if (control.dataset.arproWasDisabled !== "true") control.disabled = false;
        delete control.dataset.arproWasDisabled;
      }
    }
  }

  function setAddFormStatus(form, message, state) {
    if (!form) return;
    var status = form.querySelector("[data-arpro-form-status]");
    if (!status) return;
    status.textContent = message;
    status.dataset.state = state || "idle";
  }

  function restoreAddButton(form, submitter) {
    if (!form || !submitter || !submitter.isConnected || !("disabled" in submitter)) return;
    var explicitlyUnavailable = form.dataset.variantAvailable === "false"
      || submitter.dataset.variantAvailable === "false"
      || submitter.dataset.available === "false"
      || form.dataset.variantReady === "false"
      || submitter.dataset.variantReady === "false";
    var catalogue = form.closest("[data-arpro-catalogue]");
    var transactionBlocked = Boolean(catalogue && form.dataset.transactionReady !== "true");
    submitter.disabled = explicitlyUnavailable || transactionBlocked;
    submitter.setAttribute("aria-disabled", submitter.disabled ? "true" : "false");
  }

  async function runCartMutation(control, action) {
    if (cartMutation) {
      announce("Une mise à jour du panier est déjà en cours.");
      return null;
    }

    var mutationSucceeded = false;
    var failureMessage = "";
    setMutationControlsBusy(true);
    setControlBusy(control, true);
    cartMutation = Promise.resolve().then(action);
    try {
      var result = await cartMutation;
      mutationSucceeded = true;
      return result;
    } catch (error) {
      failureMessage = error.message || "La mise à jour du panier a échoué.";
      announce(failureMessage, true);
      return null;
    } finally {
      cartMutation = null;
      if (control && control.isConnected) setControlBusy(control, false);
      setMutationControlsBusy(false);
      if (mutationSucceeded) {
        if (!clearCheckoutWhenAuthoritative()) {
          setCheckoutBlocked(checkoutBlockReason || "État Shopify non confirmé après mise à jour ; checkout bloqué jusqu’à réconciliation.");
        }
      } else {
        setCheckoutBlocked(
          (failureMessage || "La mise à jour du panier a échoué.") +
          " État Shopify non confirmé ; checkout bloqué jusqu’à réconciliation."
        );
      }
    }
  }

  function clearCheckoutWhenAuthoritative() {
    if (uiSynchronizationLocked || readPendingContext()) return false;
    var state = authoritativeState();
    if (!state.authoritative || !state.mode || state.cartMode !== state.mode) return false;
    return clearCheckoutBlocked();
  }

  async function recoverCartAfterFailedMutation(reopenDrawer) {
    try {
      await refreshSections(reopenDrawer);
      if (clearCheckoutWhenAuthoritative()) return true;
      setCheckoutBlocked("Le panier actualisé ne confirme pas le contexte tarifaire attendu. Checkout bloqué.");
    } catch (refreshError) {
      uiSynchronizationLocked = true;
      setCheckoutBlocked("État du panier non confirmé par Shopify. Actualisez la page avant de poursuivre.");
    }
    return false;
  }

  function openDrawer(trigger, preserveFocus) {
    var drawer = document.getElementById(drawerId);
    if (!drawer || typeof drawer.showModal !== "function") return false;
    if (trigger && trigger.isConnected) lastDrawerTrigger = trigger;
    if (!drawer.open) drawer.showModal();
    document.querySelectorAll("[data-arpro-cart-open]").forEach(function (button) {
      button.setAttribute("aria-expanded", "true");
    });
    if (!preserveFocus) {
      var close = drawer.querySelector("[data-arpro-cart-close]");
      if (close) close.focus({ preventScroll: true });
    }
    return true;
  }

  function closeDrawer() {
    var drawer = document.getElementById(drawerId);
    if (drawer && drawer.open) drawer.close();
  }

  function restoreDrawerFocus() {
    document.querySelectorAll("[data-arpro-cart-open]").forEach(function (button) {
      button.setAttribute("aria-expanded", "false");
    });
    var target = lastDrawerTrigger && lastDrawerTrigger.isConnected
      ? lastDrawerTrigger
      : document.querySelector("[data-arpro-cart-open]");
    if (target) target.focus({ preventScroll: true });
  }

  function normalizeText(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function normalizedQuantityRules(option) {
    var minimum = Number(option && option.dataset.minimum);
    var increment = Number(option && option.dataset.increment);
    var maximum = option && option.dataset.maximum !== undefined && option.dataset.maximum !== ""
      ? Number(option.dataset.maximum)
      : null;
    if (!Number.isInteger(minimum) || minimum < 1) minimum = 1;
    if (!Number.isInteger(increment) || increment < 1) increment = 1;
    if (!Number.isFinite(maximum) || maximum < minimum) maximum = null;
    return { minimum: minimum, increment: increment, maximum: maximum };
  }

  function normalizeProductQuantity(input, option) {
    var rules = normalizedQuantityRules(option);
    if (!input) return rules;
    input.min = String(rules.minimum);
    input.step = String(rules.increment);
    if (rules.maximum === null) input.removeAttribute("max");
    else input.max = String(rules.maximum);

    var value = Number(input.value);
    if (!Number.isFinite(value) || value < rules.minimum) value = rules.minimum;
    if ((value - rules.minimum) % rules.increment !== 0) {
      value = rules.minimum + Math.ceil((value - rules.minimum) / rules.increment) * rules.increment;
    }
    if (rules.maximum !== null && value > rules.maximum) {
      value = rules.minimum
        + Math.floor((rules.maximum - rules.minimum) / rules.increment) * rules.increment;
    }
    input.value = String(value);
    return rules;
  }

  function saleUnitNeedsCaseSize(value) {
    var normalized = normalizeText(value);
    return normalized === "case" || normalized === "caisse" || normalized === "carton";
  }

  function saleUnitIsAllowed(value) {
    var normalized = normalizeText(value);
    return normalized === "unit" || normalized === "unite"
      || normalized === "bottle" || normalized === "bouteille"
      || normalized === "bib" || normalized === "bidon" || normalized === "coffret"
      || normalized === "case" || normalized === "caisse" || normalized === "carton";
  }

  function productOptionReadiness(option, mode) {
    var available = option && option.dataset.available === "true";
    var priceResolved = Boolean(option)
      && option.dataset.priceResolved !== "false"
      && Boolean(option.dataset.price);
    var saleUnitValue = String(option && option.dataset.saleUnit || "").trim();
    var units = Number(option && option.dataset.unitsPerCase);
    var unitsResolved = Number.isFinite(units) && units > 0;
    var caseEligibilityValue = String(option && option.dataset.caseEligible || "").trim().toLowerCase();
    var caseEligibilityResolved = Boolean(option)
      && option.dataset.caseEligibleResolved === "true"
      && (caseEligibilityValue === "true" || caseEligibilityValue === "false");
    var packResolved = saleUnitIsAllowed(saleUnitValue)
      && (!saleUnitNeedsCaseSize(saleUnitValue) || unitsResolved);

    if (mode === "GROSSISTES") {
      packResolved = packResolved
        && caseEligibilityResolved
        && (caseEligibilityValue !== "true" || unitsResolved);
    }

    return {
      available: available,
      caseEligibilityResolved: caseEligibilityResolved,
      packResolved: packResolved,
      priceResolved: priceResolved,
      ready: available && priceResolved && packResolved,
      saleUnitValue: saleUnitValue,
      units: units,
      unitsResolved: unitsResolved
    };
  }

  function syncProductMedia(productRoot, mediaId) {
    if (!productRoot) return;
    var selected = null;
    productRoot.querySelectorAll("[data-arpro-product-media-id]").forEach(function (media) {
      var active = Boolean(mediaId) && String(media.dataset.arproProductMediaId) === String(mediaId);
      media.classList.toggle("is-selected-variant-media", active);
      if (active) {
        media.setAttribute("aria-current", "true");
        selected = media;
      } else {
        media.removeAttribute("aria-current");
      }
    });
    if (selected) selected.parentElement.dataset.arproSelectedMediaId = String(mediaId);
  }

  function syncProductVariant(form, updateUrl) {
    var selector = form.querySelector("[data-arpro-variant-select]");
    var option = selector && selector.options[selector.selectedIndex];
    var productRoot = form.closest("[data-arpro-product]");
    if (!selector || !option || !productRoot) return false;

    var quantity = form.querySelector("[data-arpro-quantity]");
    var rules = normalizeProductQuantity(quantity, option);
    var price = productRoot.querySelector("[data-arpro-product-price]");
    var sku = form.querySelector("[data-arpro-product-sku]");
    var barcode = form.querySelector("[data-arpro-product-barcode]");
    var barcodeRow = form.querySelector("[data-arpro-product-barcode-row]");
    var pack = form.querySelector("[data-arpro-product-pack]");
    var saleUnit = form.querySelector("[data-arpro-product-sale-unit]");
    var unitsPerCase = form.querySelector("[data-arpro-product-units-per-case]");
    var quantityRule = form.querySelector("[data-arpro-product-quantity-rule]");
    var submit = form.querySelector("[data-arpro-add-button]") || form.querySelector("button[name='add']");
    var status = form.querySelector("[data-arpro-form-status]");
    var serverMode = normalizeMode(productRoot.dataset.arproServerMode);

    var readiness = productOptionReadiness(option, serverMode);
    var available = readiness.available;
    var priceResolved = readiness.priceResolved;
    var saleUnitValue = readiness.saleUnitValue;
    var units = readiness.units;
    var unitsResolved = readiness.unitsResolved;
    var packResolved = readiness.packResolved;
    var variantReady = readiness.ready;
    var offerResolved = priceResolved;
    if (quantity) quantity.disabled = !variantReady;

    if (price) price.textContent = offerResolved ? option.dataset.price : "Tarif à confirmer par l’ADV";
    if (sku) sku.textContent = option.dataset.sku || "Non renseigné";
    if (barcode) barcode.textContent = option.dataset.barcode || "";
    if (barcodeRow) barcodeRow.hidden = !option.dataset.barcode;
    if (pack) {
      pack.classList.toggle("is-unresolved", !packResolved);
      pack.hidden = false;
    }
    if (saleUnit) saleUnit.textContent = saleUnitValue || "À confirmer par l’ADV";
    if (unitsPerCase) {
      unitsPerCase.hidden = !unitsResolved;
      unitsPerCase.textContent = unitsResolved ? units + " unité(s) par caisse" : "";
    }
    if (quantityRule) {
      var copy = "Minimum " + rules.minimum + " · multiple de " + rules.increment;
      if (rules.maximum !== null) copy += " · maximum " + rules.maximum;
      quantityRule.textContent = copy;
    }

    form.dataset.variantAvailable = String(available);
    form.dataset.variantReady = String(variantReady);
    if (submit) {
      submit.dataset.variantAvailable = String(available);
      submit.dataset.variantReady = String(variantReady);
      submit.disabled = !variantReady;
      submit.setAttribute("aria-disabled", variantReady ? "false" : "true");
      if (!available) submit.textContent = submit.dataset.soldoutLabel || "Indisponible à la vente";
      else if (!priceResolved) submit.textContent = "Tarif à confirmer par l’ADV";
      else if (!packResolved) submit.textContent = submit.dataset.unresolvedLabel || "Conditionnement à confirmer";
      else submit.textContent = submit.dataset.availableLabel || "Ajouter au panier";
    }
    if (status) {
      if (!available) status.textContent = "Cette variante n’est pas disponible à la vente.";
      else if (!priceResolved) status.textContent = "Le tarif de cette variante doit être confirmé par l’ADV.";
      else if (!packResolved) status.textContent = "Le conditionnement ou l’éligibilité franco de cette variante n’est pas renseigné avec une valeur autorisée. Ajout bloqué.";
      else status.textContent = "";
    }

    syncProductMedia(productRoot, option.dataset.mediaId || "");
    if (updateUrl && window.history && typeof window.history.replaceState === "function") {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", option.value);
      window.history.replaceState({}, "", url.toString());
    }
    productRoot.dispatchEvent(new CustomEvent("arpro:variant:change", {
      bubbles: true,
      detail: { variantId: String(option.value), source: "product-page" }
    }));
    return true;
  }

  function initializeProductForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = [];
    if (scope.matches && scope.matches("[data-arpro-product-form]")) forms.push(scope);
    forms = forms.concat(Array.from(scope.querySelectorAll("[data-arpro-product-form]")));
    forms.forEach(function (form) {
      if (form.dataset.arproTransactionInitialized === "true") return;
      form.dataset.arproTransactionInitialized = "true";
      var selector = form.querySelector("[data-arpro-variant-select]");
      if (!selector) return;
      var productRoot = form.closest("[data-arpro-product]");
      var serverMode = normalizeMode(productRoot && productRoot.dataset.arproServerMode);
      var readyOptions = Array.prototype.filter.call(selector.options, function (option) {
        var ready = productOptionReadiness(option, serverMode).ready;
        option.dataset.variantReady = String(ready);
        option.disabled = false;
        return ready;
      });
      var fieldset = form.querySelector("[data-arpro-purchase-fieldset]");
      if (fieldset) {
        var liquidReadable = fieldset.dataset.liquidReadable === "true";
        fieldset.disabled = selector.options.length === 0 || serverMode === "" || !liquidReadable;
      }
      var selectedOption = selector.options[selector.selectedIndex];
      if (!selectedOption && readyOptions.length > 0) {
        selector.value = readyOptions[0].value;
      }
      selector.addEventListener("change", function () {
        syncProductVariant(form, true);
      });
      syncProductVariant(form, false);
    });
  }

  async function addToCart(form, submitter) {
    if (submitter && submitter.isConnected) lastDrawerTrigger = submitter;
    setAddFormStatus(form, "Ajout au panier en cours…", "loading");
    var mutationConfirmed = false;
    var sectionsSynchronized = false;
    var result = await runCartMutation(submitter || form, async function () {
      var data = new FormData(form);
      var requestedIds = sectionIds();
      data.set("sections", requestedIds.join(","));
      data.set("sections_url", sectionRequestUrl());

      var response = await fetch(cartRoute("cart/add.js"), {
        method: "POST",
        credentials: "same-origin",
        headers: { Accept: "application/json" },
        body: data
      });
      var payload = await parseResponse(response);
      mutationConfirmed = true;
      try {
        if (!payload.sections || applySections(payload.sections, true, requestedIds) !== requestedIds.length) {
          await refreshSections(true);
        }
        sectionsSynchronized = true;
      } catch (refreshError) {
        uiSynchronizationLocked = true;
        setCheckoutBlocked("Produit ajouté, mais l’affichage du panier n’a pas pu être réconcilié. Actualisation requise.");
        announce("Produit ajouté. L’affichage va être actualisé pour éviter un double ajout.", true);
        window.setTimeout(function () { window.location.reload(); }, 700);
      }
      if (sectionsSynchronized) announce("Produit ajouté au panier.");
      return payload;
    });
    if (mutationConfirmed && sectionsSynchronized) {
      setAddFormStatus(form, "Ajouté au panier.", "success");
    } else if (mutationConfirmed) {
      setAddFormStatus(form, "Ajout confirmé. Actualisation du panier en cours…", "success");
    } else {
      setAddFormStatus(form, "Ajout impossible. Vérifiez la variante et réessayez.", "error");
    }
    restoreAddButton(form, submitter);
    return result;
  }

  async function changeLine(key, quantity, control) {
    var result = await runCartMutation(control, async function () {
      var payload = await postJson("cart/change.js", {
        id: key,
        quantity: quantity
      }, { reopenDrawer: Boolean(document.getElementById(drawerId) && document.getElementById(drawerId).open) });
      announce(quantity === 0 ? "Produit retiré du panier." : "Quantité mise à jour.");
      return payload;
    });
    if (!result) {
      await recoverCartAfterFailedMutation(
        Boolean(document.getElementById(drawerId) && document.getElementById(drawerId).open)
      );
    }
    return result;
  }

  async function updateAllLines(form, submitter) {
    var updates = {};
    var invalidInput = null;
    form.querySelectorAll("[data-arpro-cart-quantity]").forEach(function (input) {
      if (input.value.trim() === "" || !input.checkValidity()) {
        invalidInput = invalidInput || input;
        return;
      }
      updates[input.dataset.lineKey] = Number(input.value);
    });
    if (invalidInput) {
      invalidInput.focus();
      if (invalidInput.value.trim() === "") {
        invalidInput.setCustomValidity("Renseignez une quantité ; un champ vide ne supprime pas la ligne.");
      }
      invalidInput.reportValidity();
      invalidInput.setCustomValidity("");
      announce("Renseignez une quantité valide avant de mettre le panier à jour.", true);
      return null;
    }
    var result = await runCartMutation(submitter || form, async function () {
      var payload = await postJson("cart/update.js", { updates: updates }, {
        reopenDrawer: Boolean(document.getElementById(drawerId) && document.getElementById(drawerId).open)
      });
      announce("Panier mis à jour.");
      return payload;
    });
    if (!result) {
      await recoverCartAfterFailedMutation(
        Boolean(document.getElementById(drawerId) && document.getElementById(drawerId).open)
      );
    }
    return result;
  }

  function readPendingContext() {
    try {
      var value = window.sessionStorage.getItem(pendingContextKey);
      var pending = value ? JSON.parse(value) : null;
      if (!pending || !pending.startedAt || Date.now() - pending.startedAt > 300000) {
        window.sessionStorage.removeItem(pendingContextKey);
        return null;
      }
      return pending;
    } catch (error) {
      return null;
    }
  }

  function writePendingContext(mode) {
    try {
      window.sessionStorage.setItem(pendingContextKey, JSON.stringify({
        mode: mode,
        startedAt: Date.now()
      }));
    } catch (error) {
      /* Server cart attributes remain the audit trail if storage is unavailable. */
    }
  }

  function clearPendingContext() {
    try {
      window.sessionStorage.removeItem(pendingContextKey);
    } catch (error) {
      /* No action required. */
    }
  }

  function authoritativeState() {
    var sources = Array.from(document.querySelectorAll("[data-arpro-context-authoritative]"));
    var allSourcesAuthoritative = sources.length > 0 && sources.every(function (source) {
      return source.dataset.arproContextAuthoritative === "true";
    });
    var modes = sources.map(function (source) {
      return normalizeMode(source.dataset.arproAuthoritativeMode);
    });
    var modesAreValid = modes.length > 0 && modes.every(Boolean);
    var mode = modesAreValid && modes.every(function (candidate) {
      return candidate === modes[0];
    }) ? modes[0] : "";

    var cartSources = sources.filter(function (source) {
      return source.hasAttribute("data-arpro-cart-price-mode");
    });
    var cartModes = cartSources.map(function (source) {
      return normalizeMode(source.dataset.arproCartPriceMode);
    });
    var cartModesAreValid = cartModes.length > 0 && cartModes.every(Boolean);
    var cartMode = cartModesAreValid && cartModes.every(function (candidate) {
      return candidate === cartModes[0];
    }) ? cartModes[0] : "";
    return {
      authoritative: allSourcesAuthoritative && Boolean(mode),
      mode: mode,
      cartMode: cartMode,
      conflict: sources.length > 0 && (!allSourcesAuthoritative || !mode)
        || cartSources.length > 0 && !cartMode
    };
  }

  async function updateCartPriceMode(mode, render) {
    var targetMode = normalizeMode(mode);
    if (!targetMode) throw new Error("Le mode tarifaire cible n’est pas valide.");
    var payload = await postJson("cart/update.js", {
      attributes: { arpro_price_mode: targetMode }
    }, { sections: render !== false, reopenDrawer: false });
    var returnedMode = normalizeMode(payload.attributes && payload.attributes.arpro_price_mode);
    if (returnedMode !== targetMode) {
      throw new Error("Shopify n’a pas confirmé le contexte tarifaire du panier.");
    }
    return payload;
  }

  async function reconcileCurrentContext() {
    if (uiSynchronizationLocked) {
      setCheckoutBlocked("Interface Shopify non réconciliée. Checkout bloqué jusqu’à une actualisation complète.");
      return;
    }
    var state = authoritativeState();
    var pending = readPendingContext();
    if (!state.authoritative || !state.mode) {
      setCheckoutBlocked(state.conflict
        ? "Les zones Shopify ne présentent pas le même contexte tarifaire. Checkout bloqué."
        : "Aucun contexte tarifaire Shopify autoritaire n’est actif. Checkout bloqué.");
      if (pending) {
        announce("Le changement de contexte tarifaire n’a pas été confirmé par Shopify.", true);
      }
      return;
    }
    if (pending && normalizeMode(pending.mode) !== state.mode) {
      setCheckoutBlocked("Le contexte demandé n’est pas devenu actif. Checkout bloqué ; choisissez à nouveau un site d’achat autorisé.");
      announce("Le changement de contexte tarifaire n’a pas été confirmé par Shopify.", true);
      return;
    }
    if (!pending && state.cartMode === state.mode) {
      clearCheckoutBlocked();
      return;
    }

    setCheckoutBlocked("Réconciliation du panier avec le contexte Shopify en cours.");
    var result = await runCartMutation(document.querySelector("[data-arpro-context-sync-message]"), async function () {
      var payload = await updateCartPriceMode(state.mode, true);
      var confirmed = authoritativeState();
      if (!confirmed.authoritative || confirmed.mode !== state.mode || confirmed.cartMode !== state.mode) {
        throw new Error("Les zones Shopify rendues ne confirment pas toutes le même contexte tarifaire.");
      }
      clearPendingContext();
      clearCheckoutBlocked();
      announce("Panier réconcilié avec le contexte tarifaire " + state.mode + ".");
      return payload;
    });
    if (!result) setCheckoutBlocked("Réconciliation non confirmée. Checkout bloqué.");
  }

  async function switchPriceContext(control) {
    var targetMode = normalizeMode(control.dataset.arproTargetMode || control.dataset.arproTargetPriceMode);
    var targetUrl = control.dataset.arproContextUrl || control.getAttribute("href");
    if (!targetMode || !targetUrl) {
      setCheckoutBlocked("Changement de contexte impossible : cible Shopify incomplète.");
      announce("Le site d’achat cible n’a pas de mode tarifaire Shopify valide.", true);
      return;
    }

    setCheckoutBlocked("Changement de contexte en cours. Checkout temporairement bloqué.");
    writePendingContext(targetMode);
    var result = await runCartMutation(control, async function () {
      var payload = await updateCartPriceMode(targetMode, false);
      window.location.assign(targetUrl);
      return payload;
    });
    if (!result) {
      setCheckoutBlocked("Le panier n’a pas pu être marqué avec le contexte cible. Checkout bloqué.");
      announce("Le changement de tarif a été annulé : Shopify n’a pas confirmé le panier.", true);
    }
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("form[action*='/cart/add']");
    if (form) {
      if (uiSynchronizationLocked || form.dataset.variantReady === "false") {
        event.preventDefault();
        setAddFormStatus(
          form,
          uiSynchronizationLocked
            ? "Ajout bloqué jusqu’à l’actualisation de l’interface Shopify."
            : "Ajout bloqué : tarif, disponibilité ou conditionnement non résolu.",
          "error"
        );
        announce("Ajout bloqué : cette variante n’est pas entièrement réconciliée.", true);
        return;
      }
      var catalogue = form.closest("[data-arpro-catalogue]");
      if (catalogue && form.dataset.transactionReady !== "true") {
        event.preventDefault();
        setAddFormStatus(form, "Ajout bloqué : le variant et son tarif Shopify ne sont pas réconciliés.", "error");
        restoreAddButton(form, event.submitter);
        announce("Ajout bloqué : cette offre n’est pas prête pour une transaction Shopify fiable.", true);
        return;
      }
      event.preventDefault();
      addToCart(form, event.submitter);
      return;
    }

    var cartForm = event.target.closest("[data-arpro-cart-form]");
    if (!cartForm) return;
    var submitter = event.submitter;
    if (submitter && submitter.name === "checkout") {
      if (uiSynchronizationLocked || checkoutBlockReason) {
        event.preventDefault();
        announce(checkoutBlockReason || "Checkout bloqué jusqu’à réconciliation de l’interface Shopify.", true);
      }
      return;
    }
    event.preventDefault();
    updateAllLines(cartForm, submitter);
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-arpro-cart-quantity]");
    if (!input) return;
    if (input.value.trim() === "") {
      input.setCustomValidity("Renseignez une quantité ; un champ vide ne supprime pas la ligne.");
      input.reportValidity();
      input.setCustomValidity("");
      announce("La quantité ne peut pas être vide.", true);
      return;
    }
    if (!input.checkValidity()) {
      input.reportValidity();
      return;
    }
    var quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) {
      announce("La quantité saisie n’est pas valide.", true);
      return;
    }
    changeLine(input.dataset.lineKey, quantity, input);
  });

  function tariffFocusVisible(element) {
    if (!element || !element.isConnected || !element.getClientRects().length) return false;
    if (element.closest("[hidden], [inert], [aria-hidden='true'], [aria-disabled='true']")) return false;
    var visibility = window.getComputedStyle(element).visibility;
    return visibility !== "hidden" && visibility !== "collapse" && !element.matches(":disabled");
  }

  function currentTariffRoot() {
    if (!lastTariffRoot) return null;
    if (lastTariffRoot.isConnected) return lastTariffRoot;
    var replacement = lastTariffRoot.id && document.getElementById(lastTariffRoot.id);
    return replacement && replacement.matches("[data-arpro-tariff-root]") ? replacement : null;
  }

  function focusTariffRoot(root) {
    if (!tariffFocusVisible(root)) return;
    var controls = root.querySelectorAll("a[href], button, input, select, textarea, summary, [tabindex], [contenteditable='true']");
    for (var index = 0; index < controls.length; index += 1) {
      var control = controls[index];
      if (control.tabIndex < 0 || !tariffFocusVisible(control)) continue;
      control.focus({ preventScroll: true });
      if (document.activeElement === control) return control;
    }
    if (!root.hasAttribute("tabindex")) root.tabIndex = -1;
    root.focus({ preventScroll: true });
    return document.activeElement === root ? root : null;
  }

  function revealTariffFocus(target) {
    if (!tariffFocusVisible(target)) return;
    var remaining = 2;
    var frame = null;
    var stopped = false;
    var inputs = ["keydown", "pointerdown", "wheel", "touchstart"];
    function stopReveal() {
      stopped = true;
      if (frame !== null) window.cancelAnimationFrame(frame);
      inputs.forEach(function (name) { document.removeEventListener(name, stopReveal, true); });
    }
    function reveal() {
      if (stopped || document.activeElement !== target || !tariffFocusVisible(target)) {
        stopReveal();
        return;
      }
      var inset = 0;
      var header = document.querySelector("[data-arpro-header-section-id]");
      if (header && !header.contains(target)) {
        var position = window.getComputedStyle(header).position;
        if (position === "sticky" || position === "fixed") {
          inset = Math.max(0, Math.min(window.innerHeight, header.getBoundingClientRect().bottom));
        }
      }
      var bounds = target.getBoundingClientRect();
      if (bounds.top < inset || bounds.bottom > window.innerHeight) {
        var availableHeight = Math.max(0, window.innerHeight - inset - 16);
        target.scrollIntoView({ behavior: "instant", block: bounds.height > availableHeight ? "start" : "center", inline: "nearest" });
        var aligned = target.getBoundingClientRect();
        if (aligned.top < inset + 8) window.scrollBy({ top: aligned.top - inset - 8, behavior: "instant" });
      }
      if (!stopped && remaining > 0) {
        remaining -= 1;
        frame = window.requestAnimationFrame(reveal);
      } else {
        stopReveal();
      }
    }
    inputs.forEach(function (name) { document.addEventListener(name, stopReveal, { capture: true, passive: true }); });
    reveal();
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || event.defaultPrevented) return;
    var root = currentTariffRoot();
    var active = document.activeElement;
    var trigger = lastTariffTrigger;
    if (!tariffFocusVisible(trigger) && trigger && trigger.isConnected && trigger.closest("[data-arpro-cart-drawer]")) {
      trigger = lastDrawerTrigger;
    }
    if (!root || !root.contains(active) || !root.contains(event.target) || !tariffFocusVisible(trigger)) return;
    var panel = active.closest("dialog, [role='dialog'], [data-arpro-filter-panel], [data-arpro-predictive]");
    if (panel && root.contains(panel)) return;
    event.preventDefault();
    event.stopPropagation();
    lastTariffTrigger = null;
    lastTariffRoot = null;
    trigger.focus({ preventScroll: true });
    revealTariffFocus(trigger);
  }, true);

  document.addEventListener("click", function (event) {
    var contextSwitch = event.target.closest("[data-arpro-tariff-context-switch], [data-arpro-location-switch]");
    if (contextSwitch) {
      event.preventDefault();
      switchPriceContext(contextSwitch);
      return;
    }

    var tariffOpen = event.target.closest("[data-arpro-tariff-open]");
    var tariffRoot = document.querySelector("[data-arpro-tariff-root]");
    if (tariffOpen && tariffRoot) {
      event.preventDefault();
      lastTariffTrigger = tariffOpen;
      lastTariffRoot = tariffRoot;
      var focusSection = function () {
        window.requestAnimationFrame(function () {
          var currentRoot = currentTariffRoot();
          if (lastTariffTrigger !== tariffOpen || !tariffOpen.isConnected || !currentRoot) return;
          var active = document.activeElement;
          if (active !== tariffOpen && active !== document.body && active !== lastDrawerTrigger && !currentRoot.contains(active)) return;
          revealTariffFocus(focusTariffRoot(currentRoot));
        });
      };
      var tariffDrawer = document.getElementById(drawerId);
      if (tariffDrawer && tariffDrawer.open) {
        tariffDrawer.addEventListener("close", focusSection, { once: true });
        closeDrawer();
      } else {
        focusSection();
      }
      return;
    }

    var open = event.target.closest("[data-arpro-cart-open]");
    if (open) {
      if (openDrawer(open, false)) event.preventDefault();
      return;
    }

    var close = event.target.closest("[data-arpro-cart-close]");
    if (close) {
      closeDrawer();
      if (close.tagName !== "A") event.preventDefault();
      return;
    }

    var remove = event.target.closest("[data-arpro-cart-remove]");
    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.lineKey, 0, remove);
      return;
    }

    var stepper = event.target.closest("[data-arpro-quantity-step]");
    if (stepper) {
      event.preventDefault();
      if (cartMutation) {
        announce("Une mise à jour du panier est déjà en cours.");
        return;
      }
      var wrapper = stepper.closest("[data-arpro-quantity]");
      var input = wrapper && wrapper.querySelector("[data-arpro-cart-quantity]");
      if (!input) return;
      var direction = Number(stepper.dataset.arproQuantityStep);
      try {
        if (direction > 0) input.stepUp(Math.abs(direction));
        else input.stepDown(Math.abs(direction));
      } catch (error) {
        var increment = Number(input.step) || 1;
        var minimum = Number(input.min) || 0;
        var maximum = input.max ? Number(input.max) : Infinity;
        if (Number.isFinite(maximum)) {
          maximum = minimum + Math.floor((maximum - minimum) / increment) * increment;
        }
        var next = Number(input.value || minimum) + direction * increment;
        input.value = Math.max(minimum, Math.min(maximum, next));
      }
      input.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    var drawer = document.getElementById(drawerId);
    if (drawer && drawer.open && event.target === drawer) closeDrawer();
  });

  document.addEventListener("cancel", function (event) {
    if (event.target && event.target.matches("[data-arpro-cart-drawer]")) {
      window.setTimeout(restoreDrawerFocus, 0);
    }
  }, true);

  document.addEventListener("close", function (event) {
    if (event.target && event.target.matches("[data-arpro-cart-drawer]")) restoreDrawerFocus();
  }, true);

  function initializeRuntime() {
    initializeProductForms(document);
    var state = authoritativeState();
    var pending = readPendingContext();
    if (pending && state.authoritative && normalizeMode(pending.mode) === state.mode && state.cartMode === state.mode) {
      clearPendingContext();
      announce("Contexte tarifaire " + state.mode + " confirmé par Shopify.");
    }
    reconcileCurrentContext();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initializeRuntime);
  else initializeRuntime();

  document.addEventListener("shopify:section:load", function (event) {
    initializeProductForms(event.target);
    reconcileCurrentContext();
  });

  document.addEventListener("arpro:sections-updated", function (event) {
    initializeProductForms(event.detail && event.detail.root ? event.detail.root : document);
    if (!cartMutation) window.setTimeout(reconcileCurrentContext, 0);
  });
})();
